/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InsuranceType = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type InsuranceType = typeof InsuranceType[keyof typeof InsuranceType];


export function instanceOfInsuranceType(value: any): boolean {
    for (const key in InsuranceType) {
        if (Object.prototype.hasOwnProperty.call(InsuranceType, key)) {
            if (InsuranceType[key as keyof typeof InsuranceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InsuranceTypeFromJSON(json: any): InsuranceType {
    return InsuranceTypeFromJSONTyped(json, false);
}

export function InsuranceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceType {
    return json as InsuranceType;
}

export function InsuranceTypeToJSON(value?: InsuranceType | null): any {
    return value as any;
}

export function InsuranceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InsuranceType {
    return value as InsuranceType;
}

